// Versão: 1.02
// Data..: 2026-09-26
// Leitura pública de um artigo da base de conhecimento, com feedback "isso ajudou?".
// v1.02: largura do artigo aproveita a página (até 1040px) e tabelas largas rolam
// dentro do card em vez de estourar o layout.

import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PublicShell } from './PublicShell.js';
import { publicApi, type PublicArticle } from '../../lib/publicApi.js';

export function PublicArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const [article, setArticle] = useState<PublicArticle | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [feedback, setFeedback] = useState<'yes' | 'no' | null>(null);

  useEffect(() => {
    if (!slug) return;
    publicApi
      .getArticle(slug)
      .then(setArticle)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  const sendFeedback = (helpful: boolean) => {
    if (!article || feedback) return;
    setFeedback(helpful ? 'yes' : 'no');
    publicApi.articleFeedback(article.id, helpful).catch(() => undefined);
  };

  return (
    <PublicShell>
      <div style={{ width: '100%', maxWidth: 1040, margin: '32px auto 64px', padding: '0 clamp(16px, 4vw, 40px)' }}>
        <Link to="/portal" className="text-sm">← Voltar para a base de conhecimento</Link>
        {loading ? (
          <div className="flex justify-center" style={{ padding: 48 }}><span className="spinner" /></div>
        ) : error || !article ? (
          <div className="card mt-4 empty">
            <div className="empty-icon">🔍</div>
            Artigo não encontrado.
          </div>
        ) : (
          <article className="card mt-4 fade-in">
            <h1>{article.title}</h1>
            <div className="text-dim text-sm mb-4">
              Atualizado em {new Date(article.updatedAt).toLocaleDateString('pt-BR')}
            </div>
            <div
              className="kb-body"
              style={{ lineHeight: 1.7 }}
              dangerouslySetInnerHTML={{ __html: article.body }}
            />
            <div style={{ borderTop: '1px solid var(--border)', marginTop: 'var(--s5)', paddingTop: 'var(--s4)' }}>
              {feedback ? (
                <div className="text-muted text-sm">Obrigado pelo seu feedback! 🙏</div>
              ) : (
                <div className="flex items-center gap-3">
                  <span className="text-muted text-sm">Este artigo foi útil?</span>
                  <button className="btn btn-sm" onClick={() => sendFeedback(true)}>👍 Sim</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => sendFeedback(false)}>👎 Não</button>
                </div>
              )}
            </div>
          </article>
        )}
        <div className="card mt-4 flex items-center justify-between" style={{ background: 'var(--surface-2)' }}>
          <span className="text-muted">Não encontrou o que procurava?</span>
          <Link to="/portal/abrir" className="btn btn-primary">Abrir um chamado</Link>
        </div>
      </div>
    </PublicShell>
  );
}
